var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentsDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46665 13.3333C4.87838 13.3333 4.39998 12.8549 4.39998 12.2667V5.86667H3.33331V4.8H4.93331H5.46665V3.73334C5.46665 3.14507 5.94505 2.66667 6.53331 2.66667H9.73331C10.3216 2.66667 10.8 3.14507 10.8 3.73334V4.8H11.3333H12.9333V5.86667H11.8666V12.2667C11.8666 12.8549 11.3882 13.3333 10.8 13.3333H5.46665ZM9.73331 3.73334H6.53331V4.8H9.73331V3.73334ZM10.2666 5.86667H5.99998H5.46665V12.2667H10.8005L10.8 5.86667H10.2666ZM7.60005 6.93334H6.53338V11.2H7.60005V6.93334ZM9.73338 6.93334H8.66671V11.2H9.73338V6.93334Z",
    fill: "#EB5757"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsDelete);
export default ForwardRef;